import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { getAllNotifications } from "../APIs/notificationsApis";
import { convertTo12HourFormat, formatDate } from "../utils/helpers";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";

const NotificationModal = ({ isnotifyModelOpen, setisnotifyModelOpen }) => {
  const {socketNotifications} = useContext(AppContext)
  const [allNotifications, setAllNotifications] = useState([]);
  useEffect(() => {
    getAllNotifications()
      .then((res) => {
        console.log(res);
        setAllNotifications(res.notifications);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    console.log(socketNotifications)

    socketNotifications  && setAllNotifications((prev) => [
      ...prev,
      socketNotifications.data,
    ]);
  },[socketNotifications])
  const handleOk = () => {
    setisnotifyModelOpen(false);
  };

  const handleCancel = () => {
    setisnotifyModelOpen(false);
  };

  useEffect(() => {
    console.log(allNotifications);
  }, [allNotifications]);
  return (
    <>
      <Modal
        open={isnotifyModelOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content h-[70vh] flex flex-col items-center py-[40px] px-[26px] sm-s:px-[15px] gap-[32px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            Notifications
          </h5>

          <div className="notification-card-wrapper flex flex-col gap-[18px] min-h-[40vh] overflow-y-auto px-[10px]">
            {allNotifications &&
              allNotifications.length > 0 &&
              allNotifications.map((notification) => {
                return (
                  <div className="notify-card px-[20px] py-[16px] flex flex-col gap-[8px] rounded-[10px] bg-white shadow-sm">
                    <p className="large font-medium text-blue font-manrope">
                      You have a deadline for the '
                      <span className="light-blue-color">
                        {notification.title}
                      </span>
                      ' case by{" "}
                      <span className="light-blue-color">
                        {convertTo12HourFormat(notification.time)}
                      </span>
                      .
                    </p>
                    <p className="font-medium small txt-color font-manrope">
                      {formatDate(notification.createdAt)}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NotificationModal;
